import { defineMessages } from 'react-intl';

export default defineMessages({
    infoYes: {
        id: 'policy.farm.directives.policy-coverage-info.Yes',
        defaultMessage: 'Yes'
    },
    infoNo: {
        id: 'policy.farm.directives.policy-coverage-info.No',
        defaultMessage: 'No'
    },
    noFarmCoveragesAvailable: {
        id: 'policy.farm.directives.policy-coverage-info.No Farm Coverages available',
        defaultMessage: 'No Farm Coverages available'
    },
    fireProtection: {
        id: 'policy.farm.directives.location.Fire Protection',
        defaultMessage: 'Fire Protection'
    },
    respondingFirehall: {
        id: 'policy.farm.directives.location.Responding Firehall',
        defaultMessage: 'Responding Firehall'
    },
    fireHallType: {
        id: 'policy.farm.directives.location.Fire Hall Type',
        defaultMessage: 'Fire Hall Type'
    },
    fullTimeFireDepartment: {
        id: 'policy.farm.directives.location.Full Time Fire Department',
        defaultMessage: 'Full Time Fire Department'
    },
    superiorShuttle: {
        id: 'policy.farm.directives.location.Superior Shuttle',
        defaultMessage: 'Superior Shuttle'
    },
    roadAccessibleYearRound: {
        id: 'policy.farm.directives.location.Road Accessible Year Round',
        defaultMessage: 'Road Accessible Year Round'
    },
    agriculturalBuildings: {
        id: 'policy.farm.directives.coverage.Agricultural Buildings',
        defaultMessage: 'Agricultural Buildings'
    },
    occupancyType: {
        id: 'policy.farm.directives.outBuilding.Occupancy Type',
        defaultMessage: 'Occupancy Type'   
    } ,
    yearBuilt: {
        id: 'policy.farm.directives.outBuilding.Year Built',
        defaultMessage: 'Year Built'   
    },
    majorUsageClass1: {
        id: 'policy.farm.directives.outBuilding.Major Usage Class 1',
        defaultMessage: 'Major Usage Class 1'   
    },
    majorUsageClass2: {
        id: 'policy.farm.directives.outBuilding.Major Usage Class 2',
        defaultMessage: 'Major Usage Class 2'   
    },
    hideOutBuildingCoverages:{
        id:'policy.farm.directives.outBuilding.Hide Building Coverages',
        defaultMessage: 'Hide Building Coverages'
    },
    showOutBuildingCoverages:{
        id:'policy.farm.directives.outBuilding.Show Building Coverages',
        defaultMessage: 'Show Building Coverages'
    },
    hideFarmCoverages:{
        id:'policy.farm.directives.farm-coverage-info.Hide Coverages',
        defaultMessage: 'Hide Coverages'
    },
    showFarmCoverages:{
        id:'policy.farm.directives.farm-coverage-info.Show Coverages',
        defaultMessage: 'Show Coverages'
    },
    noFarmOutBuildingsCoveragesAvailable: {
        id: 'farm.direcpolicytives.policy-coverage-info.No Farm Outbuildings Coverages available',
        defaultMessage: 'No Farm Outbuildings Coverages available'
    },
    heating : {
        id:'policy.farm.directives.farm-coverage-info.Heating',
        defaultMessage: 'Heating'
    },
    evaluator : {
        id:'policy.farm.directives.farm-coverage-info.Evaluator',
        defaultMessage: 'Evaluator'
    },
    estimatedReplacementCost : {
        id:'policy.farm.directives.farm-coverage-info.Estimated Replacement Cost',
        defaultMessage: 'Estimated Replacement Cost'
    },
    evaluationDate : {
        id:'policy.farm.directives.farm-coverage-info.Evaluation Date',
        defaultMessage: 'Evaluation Date'
    },
    name : {
        id:'policy.farm.directives.farm-additional-interests.Name',
        defaultMessage: 'Name'
    },
    interestType : {
        id:'policy.farm.directives.farm-additional-interests.Interest Type',
        defaultMessage: 'Interest Type'
    },
    scheduleItem : {
        id:'policy.farm.directives.farm-additional-interests.Schedule Item',
        defaultMessage: 'Schedule Item'
    },
    additionalInterests: {
        id:'policy.farm.directives.farm-additional-interests.Additional Interests',
        defaultMessage: 'Additional Interests'
    }
});
